import { useQuery } from "react-query";
import { EStudentProgressQueryKeys } from "api/endpoints/student-progress";
import { getStudentProgressByType } from "api/services/student-progress";
import { TStudentProgressByType } from "types/api/progress";
import { TApiError } from "types/api/error";

export const useStudentProgressByType = () => {
  return useQuery<TStudentProgressByType[], TApiError>(
    EStudentProgressQueryKeys.getStudentProgressByType,
    getStudentProgressByType,
    { retry: false }
  );
};
